const Create_Job = {
  JOB_PROFILE: 1,
  QUESTIONS: 2,
  RECRUITMENT: 3,
  PUBLISH: 4,
  REQUIREMENT_STEPS: 5,
  REQUIREMENT_STEPS_ROBOTIC_INTERVIEW: 6,
  REQUIREMENT_GROUP_DISCUSSION: 7,
  REQUIREMENT_F2F: 8,
  REQUIREMENT_VERIFIER: 9,
  REQUIREMENT_HR: 10,
  TECHNICAL_ASSESSMENT: 11
};
export { Create_Job };

const Job_Status = {
  DRAFT: 'DR',
  OPEN: 'OP',
  HIRED: 'HR',
  JOINED: 'JO',
  SCHEDULE: 'SC'
};
export { Job_Status };

const JobStagesShort = {
  RoboticInterview: 'RI',
  GroupDiscussion: 'GD',
  HRInterview: 'HR',
  FaceToFaceinterview: 'F2F',
  Gamification: 'Game',
  Simulation: 'Sim',
  Verification: 'Veri',
  BehavioralAssessment: 'BA',
  TechnicalAssessment: 'TA'
};
export { JobStagesShort };

const Job_Stages_Enum = {
  RoboticInterview: 'Robotic Interview',
  GroupDiscussion: 'Group Discussion',
  HRInterview: 'HR Interview',
  FaceToFaceinterview: 'Face To Face Interview',
  Gamification: 'Gamification',
  Simulation: 'Simulation',
  Verification: 'Verification',
  BehavioralAssessment: 'Behavioral Assessment',
  TechnicalAssessment: 'Technical Assessment'
};
export { Job_Stages_Enum };

const Job_Stage_Type_Enum = {
  RoboticInterview: 'interview',
  GroupDiscussion: 'discussion',
  HRInterview: 'hr',
  FaceToFaceinterview: 'face_to_face',
  Gamification: 'gamification',
  Simulation: 'simulation',
  Verification: 'verification',
  BehavioralAssessment: 'assessment',
  TechnicalAssessment: 'assessment'
};
export { Job_Stage_Type_Enum };

const Job_Stage_Icon_Enum = {
  TechnicalAssessment: 'tech-assessment-icon',
  RoboticInterview: 'robotic-interview-icon',
  BehavioralAssessment: 'behavioral-assessment-icon',
  FaceToFaceinterview: 'face-to-face-icon',
  Verification: 'verification-icon',
  Simulation: 'simulation-icon',
  Gamification: 'gamification-icon',
  GroupDiscussion: 'gd-icon',
  HRInterview: 'hr-interview-icon'
};
export { Job_Stage_Icon_Enum };

const session_keys = {
  private_key: 'PRIVATE_KEY'
};
export { session_keys };

const Job_role_Enum = {
  interviewer: 'interviewer',
  gdmoderator: 'gdmoderator',
  verifiers: 'verifier'
};
export { Job_role_Enum };

const tab_Action_Enum = {
  previous: 0,
  next: 1,
  save: 2
};
export { tab_Action_Enum };
